import '../vendor/polyfills/from';

function spin(root=document) {
  const elems = root.querySelectorAll( '.js-spin' );
  const defaults = {
    min: 0,
    max: 99,
    upClassName: 'spin__up',
    downClassName: 'spin__down',
  };
  const KEY_ARROW_UP = 38;
  const KEY_ARROW_DOWN = 40;
  const CHANGE_EVENT = new CustomEvent( 'change' );

  [ ...elems ].forEach( ( el ) => {
    const input = el.querySelector( 'input' );

    if ( input !== null ) {
      createSpin( el, input );
    }
  } );

  function createSpin( el, input ) {
    const min = +el.getAttribute( 'data-spin-min' ) || defaults.min;
    const max = +el.getAttribute( 'data-spin-max' ) || defaults.max;
    const upBtn = document.createElement( 'button' );
    const downBtn = document.createElement( 'button' );

    let value = +input.value || min;

    // down button
    downBtn.setAttribute( 'type', 'button' );
    downBtn.setAttribute( 'class', defaults.downClassName );
    downBtn.innerHTML = '<svg><use xlink:href="/img/sprite.svg#minus"></use></svg>';

    // up button
    upBtn.setAttribute( 'type', 'button' );
    upBtn.setAttribute( 'class', defaults.upClassName );
    upBtn.innerHTML = '<svg><use xlink:href="/img/sprite.svg#plus"></use></svg>';

    el.appendChild( upBtn );
    el.appendChild( downBtn );

    input.addEventListener( 'keyup', changeValue, false );

    upBtn.addEventListener( 'click', add, false );
    downBtn.addEventListener( 'click', subtract, false );

    function checkValue( newValue ) {
      let val = newValue || min;

      val = val > max ? max : val;
      val = val < min ? min : val;

      input.value = value = val;

      input.setAttribute( 'data-value', val );
      input.dispatchEvent( CHANGE_EVENT );
      $(input).trigger('change');
    }

    function changeValue( e ) {
      const code = e.keyCode ? e.keyCode : e.which;

      if ( code === KEY_ARROW_UP ) {
        add();
      } else if ( code === KEY_ARROW_DOWN ) {
        subtract();
      } else {
        checkValue( +input.value );
      }
    }

    function add() {
      checkValue( ++value );
    }

    function subtract() {
      checkValue( --value );
    }
  }
}

export default spin;
